// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1CTx0","requiredAsterisk":"Info_requiredAsterisk__24cuX"};